import { jsx as _jsx } from "@emotion/react/jsx-runtime";
import clsx from 'clsx';
import { propArrayShape, propFunc, propNumber, } from '../../../../../helpers/custom-prop-types';
const ProffitSearchLandingPagePlansTab = (props) => {
    const { currentTab, onClick, plans } = props;
    return (_jsx("div", Object.assign({ className: 'proffit_search_landing_page_plans_tab' }, { children: plans.map((v, i) => (_jsx("button", Object.assign({ className: clsx('tab_button button', currentTab === i && 'active'), onClick: onClick, type: 'button', value: i }, { children: v.short }), v.short))) })));
};
ProffitSearchLandingPagePlansTab.propTypes = {
    currentTab: propNumber().isRequired,
    onClick: propFunc().isRequired,
    plans: propArrayShape().isRequired,
};
export default ProffitSearchLandingPagePlansTab;
